<section class="sec">
    <h1 class="title">Contact</h1>
    <iframe class="card-img-top"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1959.1253932236516!2d21.3712605923073!3d46.01874253935475!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47457743f1910c37%3A0x5590d19bc72a7415!2sPepiniera%20Tuia%20si%20plante%20conifere!5e0!3m2!1sro!2sro!4v1641823928831!5m2!1sro!2sro"
        width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"></iframe>

    <div class="card-body row">
        <div class=" col-sm-6 col-xs-6 ">
            <h2 class="title1">Ne puteti Contacta </h2>
            <h5 class="card-title" style="margin-top: 20px; margin-bottom: 25px;"><img
                    src="/assets/pics/icons/adresa.svg" width="30px" height="30px">Adresa : Sat
                Firiteaz, Comuna Sagu,Judetul Arad</h5>
            <h5 class="card-title" style="margin-top: 20px; margin-bottom: 25px;"><img
                    src="/assets/pics/icons/adresa.svg" width="30px" height="30px">Arad cartier Gradiste,Judetul
                Arad
            </h5>
            <a href="tel:0733604176">
                <p class="card-text" style="margin-bottom: 25px;"><img class="icons" src="/assets/pics/icons/wapp.svg"
                        width="30px" height="30px">Speranta : 0733604176</p>
            </a>
            <a href="tel:0745631698">
                <p class="card-text" style="margin-bottom: 25px;"><img class="icons" src="/assets/pics/icons/wapp.svg"
                        width="30px" height="30px">Petru : 0745631698</p>
            </a>



            <a href="https://www.facebook.com/tuiaarborelevietii" style="margin-bottom: 25px;"><img class="icons"
                    src="/assets/pics/icons/fb.svg" width="30px" height="30px"> Facebook Link</a>
        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center title1">Orar</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Luni-Vineri</th>
                        <th scope="col">9-18</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Sambata</th>
                        <td>10-16</td>
                    </tr>
                    <tr>
                        <th scope="row">Duminica</th>
                        <td>Inchis</td>
                    </tr>


                </tbody>
            </table>


        </div>
    </div>
</section>
<hr>
<section class="mail">

    <div class="container">
        <h2>Daca aveti intrebari puteti sa ne trimiteti un mesaj in formularul de mai jos</h2>
        <div class="row">
            <div class="col-md-12 offset-xs-12">
                <form [formGroup]="FormData" (ngSubmit)="onSubmit(FormData.value)">
                    <div class="form-group">
                        <label for="Email">Email</label>
                        <input type="email" class="form-control" name="Email" aria-describedby="emailHelp"
                            placeholder="Adauga email" formControlName="Email">
                        <small id="emailHelp" class="form-text text-muted mailt">We'll never share your email with
                            anyone
                            else.</small>
                    </div>
                    <div class="form-group">
                        <label for="fullname">Nume si prenume</label>
                        <input type="text" class="form-control" name="Fullname" placeholder="Adauga Numele"
                            formControlName="Fullname">
                    </div>
                    <div class="form-group">
                        <label for="comment">Comentariu</label>
                        <textarea class="form-control" formControlName="Comment" name="Comment">
        </textarea>
                    </div>
                    <button type="submit" class="btn btn-danger" [disabled]="!FormData.valid">Submit</button>
                </form>
            </div>
        </div>
    </div>
</section>
<hr>